import CXMApiClient from "../CXMApiClient";
import { HelperFunctions } from "@/lib/utilities/HelperFunctions.js";
import DeskingApiClient from "../../api/DeskingApiClient";
import Vue from "vue";

function initialState() {
  return {
    FeatureComparisonModalInfo: {
      data: null,
      showModal: false
    }
  };
}
const state = initialState();

const actions = {
  async decodeVIN(context, request) {
    let response = await Vue.http.get(`/vehicle/vin/${request}`);
    return response && response.data && response.data.Success
      ? response.data.Data
      : null;
  },
  fetchVehicleMakes(context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/vehicle/makes/search",
          request,
          request.scope ? [request.scope] : []
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data);
          else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  fetchVehicleMakeNames(context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/vehicle/makes/search_names",
          request,
          request.scope ? [request.scope] : []
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data);
          else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  fetchVehicleModels(context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/vehicle/models/search",
          request,
          request.scope ? [request.scope] : []
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data);
          else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  fetchVehicleModelNames(context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/vehicle/models/search_names",
          request,
          request.scope ? [request.scope] : []
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data);
          else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  fetchVehicleTrims(context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/vehicle/trims/search",
          request,
          request.scope ? [request.scope] : []
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data);
          else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  fetchVehicleTrimNames(context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/vehicle/trims/search_names",
          request,
          request.scope ? [request.scope] : []
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data);
          else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  fetchVehicleColorsByTrimId(context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/vehicle/trims/color",
          request,
          request.scope ? [request.scope] : []
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data);
          else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  getVehicleYearsForDealer(context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/vehicle/years/dealer_years",
          request,
          request.scope ? [request.scope] : []
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data);
          else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  async getDealerPlanPrice(context, request) {
    let cxmApiClient = new CXMApiClient();
    return await cxmApiClient
      .ProcessRequest(
        "POST",
        "/vehicle/trims/dealer_plan_price",
        request,
        request.scope ? [request.scope] : []
      )
      .catch(ex => ex.response);
  },
  async getVehicleImage(context, request) {
    let cxmApiClient = new CXMApiClient();
    return await cxmApiClient
      .ProcessRequest(
        "POST",
        "/vehicle/trims/vehicle_image",
        request,
        request.scope ? [request.scope] : []
      )
      .catch(ex => ex.response);
  },
  updateFeatureComparisonModalInfo: function(context, data) {
    context.commit("updateFeatureComparisonModalInfo", data);
  },
  loadVehicleFeatureComparisons: function(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/vehicle/trims/feature_comparison",
          request,
          scope
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data.data);
          else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  loadVehicleFuelComparisons: function(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/vehicle/trims/fuel_economy_comparison",
          request,
          scope
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data.data);
          else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  async getVehicleMakesForDesking(context, request) {
    let client = new DeskingApiClient();
    let response = await client.ProcessRequest(
      "POST",
      "/api/desking/vehicle/make/search",
      request
    );
    return response && response.data.successful ? response.data : null;
  },
  async getVehicleModelsForDesking(context, request) {
    let client = new DeskingApiClient();
    let response = await client.ProcessRequest(
      "POST",
      "/api/desking/vehicle/model/search",
      request
    );
    return response && response.data.successful ? response.data : null;
  },
  async getVehicleYearsForDesking(context, request) {
    let client = new DeskingApiClient();
    let response = await client.ProcessRequest(
      "POST",
      "/api/desking/vehicle/year/search",
      request
    );
    return response && response.data.successful ? response.data : null;
  },
  async getVehicleTrimsForDesking(context, request) {
    let client = new DeskingApiClient();
    let response = await client.ProcessRequest(
      "POST",
      "/api/desking/vehicle/trim/search",
      request
    );
    return response && response.data.successful ? response.data : null;
  },
  async sendVinDecodeRequest(context, request) {
    let client = new DeskingApiClient();
    try {
      let response = await client.ProcessRequest(
        "POST",
        "/api/desking/vehicle/decode_vin",
        request
      );
      return response && response.data && response.data.successful
        ? response
        : null;
    } catch (ex) {
      return null;
    }
  }
};

const mutations = {
  updateFeatureComparisonModalInfo: function(state, data) {
    state.FeatureComparisonModalInfo = data;
  }
};

export default {
  actions,
  mutations,
  state
};



// WEBPACK FOOTER //
// ./src/store/modules/Vehicles.js